var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// - Import react components
import { db } from 'data/firestoreClient';
import { SocialError } from 'core/domain/common';
import { injectable } from 'inversify';
/**
 * Firbase post service
 *
 * @export
 * @class PostService
 * @implements {IPostService}
 */
var PostService = /** @class */ (function () {
    function PostService() {
        var _this = this;
        this.addPost = function (post) {
            return new Promise(function (resolve, reject) {
                var postRef = db.collection("posts").doc();
                postRef.set(__assign({}, post, { id: postRef.id }))
                    .then(function () {
                    resolve(postRef.id);
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Updare post
         */
        this.updatePost = function (post) {
            return new Promise(function (resolve, reject) {
                var batch = db.batch();
                var postRef = db.doc("posts/" + post.id);
                batch.update(postRef, __assign({}, post));
                batch.commit().then(function () {
                    resolve();
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Delete post
         */
        this.deletePost = function (postId) {
            return new Promise(function (resolve, reject) {
                var batch = db.batch();
                var postRef = db.doc("posts/" + postId);
                batch.delete(postRef);
                batch.commit().then(function () {
                    resolve();
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Get the posts of tie users with the user with {userId} identifier and it's owen posts
         */
        this.getPosts = function (currentUserId, lastPostId, page, limit) {
            if (page === void 0) { page = 0; }
            if (limit === void 0) { limit = 10; }
            return new Promise(function (resolve, reject) {
                var postList = [];
                // Get user ties
                db.collection('graphs:users').where('leftNode', '==', currentUserId)
                    .get().then(function (tieUsers) {
                    if (!(tieUsers.size > 0)) {
                        // Get current user posts
                        _this.getPostsByUserId(currentUserId, lastPostId, page, limit).then(function (result) {
                            resolve(result);
                        });
                    }
                    var userCounter = 0;
                    var userIdList = [];
                    tieUsers.forEach(function (item) {
                        var userId = item.data().rightNode;
                        if (!userIdList.includes(userId)) {
                            // Get user tie posts
                            _this.getPostsByUserId(userId).then(function (posts) {
                                userCounter++;
                                postList = postList.concat(posts.posts);
                                if (userCounter === tieUsers.size) {
                                    // Get current user posts
                                    _this.getPostsByUserId(currentUserId).then(function (result) {
                                        postList = postList.concat(result.posts);
                                        resolve(_this.pagingPosts(postList, lastPostId, limit));
                                    });
                                }
                            });
                        }
                    });
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Get list of post by user identifier
         */
        this.getPostsByUserId = function (userId, lastPostId, page, limit) {
            if (limit === void 0) { limit = 15; }
            return new Promise(function (resolve, reject) {
                var parsedData = [];
                var query = db.collection('posts').where('ownerUserId', '==', userId);
                if (lastPostId && lastPostId !== '') {
                    query = query.orderBy('id')
                        .orderBy('creationDate', 'desc')
                        .orderBy('available', 'desc')
                        .startAfter(lastPostId);
                }
                if (limit) {
                    query = query.limit(limit);
                }
                query.get().then(function (posts) {
                    var newLastPostId = posts.size > 0 ? posts.docs[posts.docs.length - 1].id : '';
                    posts.forEach(function (postResult) {
                        var _a;
                        var post = postResult.data();
                        parsedData = parsedData.concat([
                            (_a = {},
                                _a[postResult.id] = __assign({ id: postResult.id }, post),
                                _a)
                        ]);
                    });
                    resolve({ posts: parsedData, newLastPostId: newLastPostId });
                });
            });
        };
        this.getPostsByUserName = function (userName, lastPostId, page, limit) {
            if (limit === void 0) { limit = 15; }
            return new Promise(function (resolve, reject) {
                var parsedData = [];
                var query = db.collection('posts').where('ownerUserName', '==', userName);
                if (lastPostId && lastPostId !== '') {
                    query = query.orderBy('id')
                        .orderBy('creationDate', 'desc')
                        .orderBy('available', 'desc')
                        .startAfter(lastPostId);
                }
                if (limit) {
                    query = query.limit(limit);
                }
                query.get().then(function (posts) {
                    var newLastPostId = posts.size > 0 ? posts.docs[posts.docs.length - 1].id : '';
                    posts.forEach(function (postResult) {
                        var _a;
                        var post = postResult.data();
                        parsedData = parsedData.concat([
                            (_a = {},
                                _a[postResult.id] = __assign({ id: postResult.id }, post),
                                _a)
                        ]);
                    });
                    resolve({ posts: parsedData, newLastPostId: newLastPostId });
                });
            });
        };
        this.getPurchases = function (userId, lastPostId, page, limit) {
            return new Promise(function (resolve, reject) {
                var parsedData = [];
                var query = db.collection('purchases').where('buyerId', '==', userId);
                if (lastPostId && lastPostId !== '') {
                    query = query.orderBy('id').orderBy('creationDate', 'desc').startAfter(lastPostId);
                }
                if (limit) {
                    query = query.limit(limit);
                }
                query.get().then(function (posts) {
                    var newLastPostId = posts.size > 0 ? posts.docs[posts.docs.length - 1].id : '';
                    posts.forEach(function (postResult) {
                        var _a;
                        var post = postResult.data();
                        // console.log('QUERYuserid' , query)
                        parsedData = parsedData.concat([
                            (_a = {},
                                _a[postResult.id] = __assign({ id: postResult.id }, post),
                                _a)
                        ]);
                    });
                    resolve({ posts: parsedData, newLastPostId: newLastPostId });
                });
            });
        };
        this.getPostsByType = function (Type, lastPostId, page, limit) {
            return new Promise(function (resolve, reject) {
                var parsedData = [];
                var query;
                if (Type === 'Mens' || Type === 'Womens') {
                    query = db.collection('posts').where('Gender', '==', Type);
                }
                else {
                    query = db.collection('posts').where('Type', '==', Type) || db.collection('posts').where('Gender', '==', Type);
                }
                if (lastPostId && lastPostId !== '') {
                    query = query
                        .orderBy('id')
                        .orderBy('available', 'desc')
                        .orderBy('creationDate', 'desc')
                        .startAfter(lastPostId);
                }
                if (limit) {
                    query = query.limit(limit);
                }
                query.get().then(function (posts) {
                    var newLastPostId = posts.size > 0 ? posts.docs[posts.docs.length - 1].id : '';
                    posts.forEach(function (postResult) {
                        var _a;
                        var post = postResult.data();
                        // console.log('QUERY' , post)
                        parsedData = parsedData.concat([
                            (_a = {},
                                _a[postResult.id] = __assign({ id: postResult.id }, post),
                                _a)
                        ]);
                    });
                    resolve({ posts: parsedData, newLastPostId: newLastPostId });
                });
            });
        };
        this.getPostsByConstraints = function (Type, Constraint, lastPostId, page, limit) {
            return new Promise(function (resolve, reject) {
                var parsedData = [];
                var query;
                // if (Type === 'Mens' || Type === 'Womens') {
                //    query = db.collection('posts').where('Gender', '==', Type)
                //   } 
                // else {
                query = db.collection('posts').where('Type', '==', Type).where('Gender', '==', Constraint);
                // }
                if (lastPostId && lastPostId !== '') {
                    query = query.orderBy('id').orderBy('creationDate', 'desc').startAfter(lastPostId);
                }
                if (limit) {
                    query = query.limit(limit);
                }
                query.get().then(function (posts) {
                    var newLastPostId = posts.size > 0 ? posts.docs[posts.docs.length - 1].id : '';
                    posts.forEach(function (postResult) {
                        var _a;
                        var post = postResult.data();
                        // console.log('QUERY' , post)
                        parsedData = parsedData.concat([
                            (_a = {},
                                _a[postResult.id] = __assign({ id: postResult.id }, post),
                                _a)
                        ]);
                    });
                    resolve({ posts: parsedData, newLastPostId: newLastPostId });
                });
            });
        };
        /**
         * Get post by the post identifier
         */
        this.getPostById = function (postId) {
            return new Promise(function (resolve, reject) {
                var postsRef = db.doc("posts/" + postId);
                postsRef.get().then(function (snapshot) {
                    var newPost = snapshot.data() || {};
                    var post = __assign({ id: postId }, newPost);
                    resolve(post);
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Pagination calculation
         * TODO: Needs to be optimized by server pagination calculation on {dateByMonth:[post1,post2,post3]} from `userInfo.posts`
         */
        this.pagingPosts = function (postList, lastPostId, limit) {
            var sortedObjects = postList.sort(function (a, b) {
                var aKey = Object.keys(a)[0];
                var bKey = Object.keys(b)[0];
                // a = current item in array
                // b = next item in array
                return b[bKey].creationDate - a[aKey].creationDate;
            });
            if (lastPostId && lastPostId !== '') {
                var lastPostIndex = sortedObjects.findIndex(function (arg) {
                    return Object.keys(arg)[0] === lastPostId;
                });
                sortedObjects = sortedObjects.slice(lastPostIndex + 1, lastPostIndex + limit + 1);
            }
            else if (sortedObjects.length > limit) {
                sortedObjects = sortedObjects.slice(0, limit);
            }
            var newLastPostId = sortedObjects && sortedObjects.length > 0 ? Object.keys(sortedObjects[sortedObjects.length - 1])[0] : '';
            return { posts: sortedObjects, newLastPostId: newLastPostId };
        };
    }
    PostService = __decorate([
        injectable()
    ], PostService);
    return PostService;
}());
export { PostService };



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/services/posts/PostService.ts
// module id = 306
// module chunks = 50